import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BASE_URL = "https://nissi-india.com";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function s(v) {
  return (v ?? "").toString().trim();
}

const MonthlyWorkingDayReportPrint = () => {
  const q = useQuery();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Edit these once to match your company header exactly
  const company = useMemo(
    () => ({
      name: "Nissi Infotech",
      sub1: "Nissi",
      sub2: "CIVIL CONSTRUCTION",
      addressLeft: "3/42-12, Nagappa colony , kavundampalayam,",
      addressRight: "Coimbatore - 641030 . Tamil Nadu. India .",
      phone: "Phone No : 9003744644",
      email: "infraconsoft-implementation@nissiinfotech.in",
      // Put your logo in /public and set this path:
      // logoUrl: "/nissi-logo.png",
      logoUrl: "", // leave blank if not available
    }),
    []
  );

  const params = useMemo(() => {
    return {
      finYearId: s(q.get("finYearId")),
      branchId: s(q.get("branchId")),
      branchType: s(q.get("branchType")),
      siteId: s(q.get("siteId")),
      monthName: s(q.get("monthName")),
      year: s(q.get("year")),
      fromDate: s(q.get("fromDate")),
      toDate: s(q.get("toDate")),
      empCode: s(q.get("empCode")),
      empName: s(q.get("empName")),
    };
  }, [q]);

  useEffect(() => {
    const run = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${BASE_URL}/api/monthly-working-day/print-data`, {
          params: {
            finYearId: Number(params.finYearId),
            branchId: Number(params.branchId),
            branchType: params.branchType,
            siteId: params.siteId,
            monthName: params.monthName,
            year: params.year,
            fromDate: params.fromDate,
            toDate: params.toDate,
            empCode: params.empCode,
            empName: params.empName,
          },
        });

        if (res?.data?.success) setRows(res.data.rows || []);
        else setRows([]);
      } catch {
        setRows([]);
      } finally {
        setLoading(false);
        setTimeout(() => window.print(), 500);
      }
    };

    run();
  }, [params]);

  return (
    <div className="print-root">
      {/* Toolbar (hidden in print) */}
      <div className="toolbar no-print">
        <button onClick={() => window.print()} className="btn">
          Print
        </button>
        <button onClick={() => window.close()} className="btn">
          Close
        </button>
      </div>

      <div className="page">
        {/* Outer border box like screenshot */}
        <div className="outer-box">
          {/* Company header block */}
          <div className="company-box">
            <div className="company-row">
              <div className="logo-cell">
                {company.logoUrl ? (
                  <img src={company.logoUrl} alt="logo" className="logo" />
                ) : (
                  <div className="logo-placeholder" />
                )}
              </div>

              <div className="company-center">
                <div className="company-name">{company.name}</div>
                <div className="company-sub">{company.sub1}</div>
                <div className="company-sub bold">{company.sub2}</div>

                <div className="company-address">
                  <span>{company.addressLeft}</span>
                  <span>{company.addressRight}</span>
                </div>

                <div className="company-contact">
                  <span>{company.phone}</span>
                  <span>{company.email}</span>
                </div>
              </div>

              <div className="company-right">
                {/* keep empty to mimic spacing in screenshot */}
              </div>
            </div>
          </div>

          {/* Title row */}
          <div className="title-row">MONTHLY WORKING DAY REPORT</div>

          {/* (Optional) filter info row - remove if you don't want */}
          <div className="filter-row">
            <div>
              <b>Month:</b> {params.monthName} &nbsp; <b>Year:</b> {params.year}
            </div>
            <div>
              <b>From:</b> {params.fromDate || "-"} &nbsp; <b>To:</b> {params.toDate || "-"}
            </div>
            <div>
              <b>Emp Code:</b> {params.empCode || "-"} &nbsp; <b>Name:</b> {params.empName || "-"}
            </div>
          </div>

          {/* Table */}
          <div className="table-wrap">
            <table className="report-table">
              <thead>
                <tr>
                  <th style={{ width: "55px" }}>S.No</th>
                  <th style={{ width: "110px" }}>Employee Code</th>
                  <th>Emplyee Name</th>
                  <th style={{ width: "140px" }}>Designation</th>
                  <th style={{ width: "90px" }}>Days Worked</th>
                  <th style={{ width: "90px" }}>Leave Taken</th>
                  <th style={{ width: "80px" }}>Holidays</th>
                  <th style={{ width: "80px" }}>Absence</th>
                  <th style={{ width: "70px" }}>LOP</th>
                  <th style={{ width: "120px" }}>Total Working Days</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={10} className="center muted">
                      Loading...
                    </td>
                  </tr>
                ) : rows.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="center muted">
                      No Records Found
                    </td>
                  </tr>
                ) : (
                  rows.map((r, idx) => (
                    <tr key={idx}>
                      <td className="center">{idx + 1}</td>
                      <td className="center">{r.fld_employeecode}</td>
                      <td className="center">{r.fld_employee}</td>
                      <td className="center">{r.fld_designationname}</td>

                      {/* In your ASP grid: present=Days Worked, leave=Leave Taken, holidays, absentees=Absence, lop, Workingdays=Total Working Days */}
                      <td className="center">{r.present}</td>
                      <td className="center">{r.leave}</td>
                      <td className="center">{r.holidays}</td>
                      <td className="center">{r.absentees}</td>
                      <td className="center">{r.lop}</td>
                      <td className="center">{r.Workingdays}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* footer spacing like screenshot */}
          <div className="bottom-space" />
        </div>
      </div>

      {/* Print CSS (matches screenshot style) */}
      <style>{`
        .print-root { background: #999; padding: 18px; }
        .toolbar { display: flex; gap: 10px; margin-bottom: 12px; }
        .btn {
          background: #111;
          color: #fff;
          border: 0;
          padding: 10px 14px;
          border-radius: 10px;
          font-weight: 700;
          cursor: pointer;
        }

        .page {
          background: #fff;
          width: 1050px;           /* similar to screenshot width */
          margin: 0 auto;
          padding: 22px;
          box-shadow: 0 10px 30px rgba(0,0,0,.25);
        }

        .outer-box {
          border: 2px solid #000;
          padding: 14px;
        }

        .company-box {
          border: 1px solid #000;
          padding: 10px;
        }

        .company-row {
          display: grid;
          grid-template-columns: 120px 1fr 120px;
          gap: 10px;
          align-items: center;
        }

        .logo-cell { display: flex; justify-content: center; }
        .logo { width: 90px; height: 70px; object-fit: contain; }
        .logo-placeholder {
          width: 90px; height: 70px; border: 1px solid #000;
        }

        .company-center { text-align: center; }
        .company-name { font-size: 20px; font-weight: 800; }
        .company-sub { font-size: 12px; line-height: 1.2; }
        .company-sub.bold { font-weight: 800; letter-spacing: 0.3px; }
        .company-address { font-size: 12px; margin-top: 2px; }
        .company-address span { display: inline-block; margin: 0 4px; }
        .company-contact { font-size: 12px; margin-top: 4px; display: flex; justify-content: space-between; gap: 10px; }
        .company-right { /* keep empty */ }

        .title-row {
          margin-top: 14px;
          border-top: 1px solid #000;
          border-bottom: 1px solid #000;
          padding: 10px 0;
          text-align: center;
          font-size: 18px;
          font-weight: 900;
          letter-spacing: 0.6px;
        }

        .filter-row{
          padding: 8px 4px 10px;
          font-size: 12px;
          display: flex;
          justify-content: space-between;
          gap: 12px;
        }

        .table-wrap { margin-top: 10px; }
        .report-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
        }
        .report-table th, .report-table td {
          border: 1px solid #000;
          padding: 8px 6px;
          vertical-align: middle;
        }
        .report-table th {
          font-weight: 800;
          text-align: center;
        }
        .center { text-align: center; }
        .muted { color: #444; }

        .bottom-space { height: 280px; } /* big whitespace like screenshot */

        @media print {
          .no-print { display: none !important; }
          .print-root { background: #fff; padding: 0; }
          .page { box-shadow: none; width: auto; padding: 0; }
          @page { size: A4 landscape; margin: 10mm; }
        }
      `}</style>
    </div>
  );
};

export default MonthlyWorkingDayReportPrint;
